export const isNullOrWhiteSpace = (str) =>
  str == null || String(str).trim() === "";

export const fmtDateTime = (d) => {
  if (!d) return "-";
  const date = new Date(d);
  if (isNaN(date.getTime())) return "-";
  const pad = (n) => n.toString().padStart(2, "0");
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = pad(date.getMinutes());
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} ${pad(hours)}:${minutes} ${ampm}`;
};

export const dateOrDash = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : "—";

export const getPriority = (severity) => {
  if (!severity || !String(severity).trim()) return "Low";
  const s = String(severity).trim();
  const sLower = s.toLowerCase();
  if (s === "1") return "Critical";
  if (s === "2") return "High";
  if (s === "3") return "Medium";
  if (s === "4") return "Low";
  if (sLower === "critical" || sLower === "urgent") return "Critical";
  if (sLower === "high") return "High";
  if (sLower === "medium" || sLower === "moderate") return "Medium";
  if (sLower === "low") return "Low";
  if (sLower.includes("urgent") || sLower.includes("critical"))
    return "Critical";
  if (sLower.includes("high")) return "High";
  if (sLower.includes("medium") || sLower.includes("moderate"))
    return "Medium";
  return "Low";
};

export const resolveActionRequired = (
  remediation,
  comment,
  category,
  severity,
) => {
  const clean = (v) => (typeof v === "string" ? v.trim() : "");
  if (clean(remediation)) return clean(remediation);
  if (clean(comment)) return clean(comment);
  if (clean(category)) return clean(category);
  if (clean(severity)) return getPriority(severity);
  return "";
};
